/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import accountStore from "../store/accountStore";
import { Spinner } from "../../../components/ui/Spinner";
import { useMediaQuery } from "react-responsive";
import { observer } from "mobx-react-lite";
import ProductCard from "../../../components/ProductCard";
import appStore from "../../../stores/appStore";
import { InformationPopover } from "../../../components/ui";

const Favorites = () => {
  useEffect(() => {
    accountStore.getFavorites();
  }, []);

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const mobileStyles = {
    container: isMobile ? "flex-col p-2 gap-2" : "flex-row p-[20px] gap-[20px]",
    sidebar: isMobile
      ? "flex-row w-full overflow-x-auto gap-4 p-2 bg-white rounded-lg"
      : "flex-col rounded-2xl h-max bg-white p-[20px] gap-[20px] min-w-[250px] shadow-[0_2px_20px_#0000001a]",
    menuItem: isMobile
      ? "text-base whitespace-nowrap"
      : "text-[18px] tracking-[-2%]",
    content: isMobile ? "w-full mt-2" : " w-[800px] text-[#232323]",
  };

  return (
    <div className={`flex flex-col gap-[20px] ${mobileStyles.content}`}>
      <h2 className={`${isMobile ? "text-xl" : "text-[20px]"} font-semibold flex items-center gap-2`}>
        <span>Избранное</span>
        <InformationPopover title="Избранное" content={<>
          <p>В избранном вы можете сохранять понравившиеся товары, чтобы вернуться к ним позже.</p>
          <p>Если вы авторизируетесь, то сможете просматривать сохраненные товары на разных устройствах — они сохранятся в профиле.</p>
          </>} position="bottom"></InformationPopover>
      </h2>
      {accountStore.isLoading ? (
        <div className="flex justify-center items-center h-64">
          <Spinner size="lg" />
        </div>
      ) : (
        <div>
          {(() => {
            // ...existing code...
            const currentCityProducts =
              accountStore.favorites?.filter(
                (product) => product.stocks.some((i) => i.Stock.includes(appStore.selectedCity))
              ) || [];
            const otherCitiesProducts =
              accountStore.favorites?.filter(
                (product) => !product.stocks.some((i) => i.Stock.includes(appStore.selectedCity))
              ) || [];

            const hasCurrentCity = currentCityProducts.length > 0;
            const hasOtherCities = otherCitiesProducts.length > 0;
            const shouldDivide = hasCurrentCity && hasOtherCities;
            const hasFavorites = accountStore?.favorites && accountStore.favorites.length > 0;

            // ...existing code renderProductGrid...

            const renderProductGrid = (
              products: typeof accountStore.favorites
            ) => {
              // ...existing code...
              const totalItems = products?.length || 0;
              const itemsPerRow = {
                base: 1,
                sm: 2,
                md: 3,
                lg: 4,
              };
              return products?.map((product, index) => {
                // ...existing code...
                // const globalIndex = startIndex + index; // удалено, не используется
                const isFirstInRow = {
                  base: index % itemsPerRow.base === 0,
                  sm: index % itemsPerRow.sm === 0,
                  md: index % itemsPerRow.md === 0,
                  lg: index % itemsPerRow.lg === 0,
                };
                const isLastInRow = {
                  base: (index + 1) % itemsPerRow.base === 0,
                  sm: (index + 1) % itemsPerRow.sm === 0,
                  md: (index + 1) % itemsPerRow.md === 0,
                  lg: (index + 1) % itemsPerRow.lg === 0,
                };
                const isFirstRow = index < itemsPerRow.lg;
                const isLastRow =
                  index >=
                  totalItems -
                    (totalItems % itemsPerRow.lg || itemsPerRow.lg);
                const borderClasses = [
                  "border-[#54545657] border-b-[1px]",
                  isFirstRow ? "" : "",
                  isLastRow ? "!border-b-[0px]" : "",
                  isFirstInRow.base ? "!border-l-0" : "border-l-[1px]",
                  isLastInRow.base ? "border-r-0" : "border-r-[1px]",
                  "",
                  isFirstInRow.sm ? "sm:border-l-0" : "sm:border-l-[1px]",
                  isLastInRow.sm ? "sm:border-r-0" : "sm:border-r-[1px]",
                  "",
                  isFirstInRow.md ? "md:border-l-0" : "md:border-l-[1px]",
                  isLastInRow.md ? "md:border-r-0" : "md:border-r-[1px]",
                  "",
                  isFirstInRow.lg
                    ? "!border-l-0 !rounded-lt-[20px]"
                    : "lg:border-l-[1px]",
                  isLastInRow.lg
                    ? "!border-r-0 !rounded-rt-[20px]"
                    : "lg:border-r-[1px]",
                ]
                  .filter(Boolean)
                  .join(" ");
                return (
                  <ProductCard
                    key={product.ref_key}
                    className={borderClasses}
                    product={product}
                  />
                );
              });
            };

            // ...existing code return...
            return (
              <>
                {hasFavorites ? (
                  <>
                    {shouldDivide ? (
                      <>
                        {/* Товары в текущем городе */}
                        <div
                          className={
                            "grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 rounded-2xl bg-white " +
                            (isMobile
                              ? "bg-white rounded-2xl w-full"
                              : "bg-white rounded-[20px] w-[1000px] p-[6px] shadow-[0_2px_20px_#0000001a]")
                          }
                        >
                          {renderProductGrid(currentCityProducts)}
                        </div>

                        {/* Разделитель */}
                        <div
                          className={
                            !isMobile
                              ? "my-6 px-4 "
                              : "mt-[20px]  px-[30px] self-start"
                          }
                        >
                          <h2
                            className={
                              !isMobile
                                ? "text-[1.68rem] font-bold text-[#232323] tracking-[-2%]"
                                : "text-[17px] font-bold text-[#232323] text-left tracking-[-2%]"
                            }
                          >
                            В наличии в других городах
                          </h2>
                        </div>

                        {/* Товары в других городах */}
                        <div
                          className={
                            "grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 rounded-2xl " +
                            (isMobile
                              ? "bg-white rounded-2xl w-full"
                              : "bg-white rounded-[20px] w-[1000px] p-[6px] shadow-[0_2px_20px_#0000001a]")
                          }
                        >
                          {renderProductGrid(otherCitiesProducts)}
                        </div>
                      </>
                    ) : (
                      // Если только одна группа - отображаем как раньше
                      <div
                        className={
                          "grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 rounded-2xl " +
                          (isMobile
                            ? "bg-white rounded-2xl w-full"
                            : "bg-white rounded-[20px] w-[1000px] p-[6px] shadow-[0_2px_20px_#0000001a]")
                        }
                      >
                        {renderProductGrid(accountStore.favorites || [])}
                      </div>
                    )}
                  </>
                ) : (
                  <div
                    className={`bg-white ${
                      isMobile
                        ? "rounded-lg p-4"
                        : "rounded-[20px] p-[30px] shadow-[0_2px_20px_#0000001a]"
                    }  w-full`}
                  >
                    <h2>У вас пока нет товаров в избранном</h2>
                  </div>
                )}
              </>
            );
          })()}
        </div>
      )}
    </div>
  );
};

const ObservedFavorites = observer(Favorites);
export default ObservedFavorites;
